import { render } from "./MySpaceView.vue?vue&type=template&id=364489ce"
import script from "./MySpaceView.vue?vue&type=script&lang=js"
export * from "./MySpaceView.vue?vue&type=script&lang=js"

import "./MySpaceView.vue?vue&type=style&index=0&id=364489ce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__